<div class="slider" id='sliderMain'>
    <div class="slider__slide slider__slide--1">
      <div class="slider__img slider__img--1"></div>
      <div class="slider__text slider__text--1">
        <h1 class="slider__header">Rejuvenate your, true self.</h1>
        <a href="ign.com" class="cta">discover</a>
      </div>
    </div>
    
    <div class="slider__slide slider__slide--2">
      <div class="slider__img slider__img--2"></div>
      <div class="slider__text slider__text--2">
        <h1 class="slider__header">Professonial, trust-worthy, and compassionate.</h1>
        <a href="google.com" class="cta">learn more</a>
      </div>
    </div>
    
      <div class="slider__slide slider__slide--3">
      <div class="slider__img slider__img--3"></div>
      <div class="slider__text slider__text--3">
        <h1 class="slider__header">Trust in us.</h1>
        <a href="youtube.com" class="cta">learn more</a>
      </div>
    </div>
    
    <div class="slider__slide slider__slide--4">
      <div class="slider__img slider__img--4"></div>
      <div class="slider__text slider__text--4">
        <h1 class="slider__header">What we do.</h1>
        <a href="tsn.ca" class="cta">discover</a>
      </div>
    </div>
    
    <div class="slider__navigation">
      <div class="slider__count slider__count--top">
        <p class="count count--top count--top-1">01</p>
        <p class="count count--top count--top-2">02</p>
        <p class="count count--top count--top-3">03</p>      
        <p class="count count--top count--top-4">04</p>
      </div>
      
      <div class="slider__bar">
        <div id="sliderBarDynamic" class="slider__bar--dynamic"></div>
        <div class="slider__bar--static"></div>
      </div>
      
       <div class="slider__count slider__count--bottom">
        <p class="count count--bottom count--bottom-1">02</p>
        <p class="count count--bottom count--bottom-2">03</p>
        <p class="count count--bottom count--bottom-3">04</p>      
        <p class="count count--bottom count--bottom-3">01</p>
      </div>
    </div>
  </div>